<script>
	import { onMount } from "svelte";
	import { navigate } from "svelte-navigator";

	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";

	import PageSection from "../../components/PageSection.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import PrimaryButton from "../../components/buttons/PrimaryButton.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";

	export let pageTitle = null;
	export let lastVisitedPage = null;

	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	//  Get the user Agent
	let validationCode = "";
	let accessTokenRequested = false;
	let validationFailed = false;
	$: nextBtnDisabled = !(validationCode && validationCode.length === 6);

	onMount(() => {
		accessTokenRequested = false;
	});

	const post = async (url, data) => {
		let options = {
			method: "POST",
			headers: {
				"Content-type": "application/json"
			},
			body: JSON.stringify(data)
		};

		let response = await fetch(`${url}`, options);
		if (!response.ok) {
			console.error("Error:".response);

			return null;
		} else {
			if (response.status != 204) {
				let data = await response.json();

				return data;
			}
		}
	};

	const get = async (url) => {
		let options = {
			method: "GET",
			headers: {
				"Content-type": "application/json"
			}
		};

		let response = await fetch(`${url}`, options);
		if (!response.ok) {
			console.error("Error:".response);

			return null;
		} else {
			let data = await response.json();

			return data;
		}
	};

	const requestToken = async () => {
		try {
			accessTokenRequested = true;

			let url = `/api/code-request?token=${$model.RegistrationToken}`;
			await fetch(url, {
				method: "GET",
				headers: {
					"Content-type": "application/json"
				}
			});
		} catch (err) {
			console.log("Unexpected result:", err);
			if (err.response) {
				let response = JSON.parse(err.response);
				alert(response.errorMessage);
			} else {
				navigate("Error");
			}
			return false;
		}
	};

	const validateCode = async function () {
		console.log("Validating");

		nextBtnDisabled = true;

		var status = await verify();
		if (status) {
			//  Get the Registration
			navigateNext();
		} else {
			validationFailed = true;
			console.log("Invalid Code");
		}
	};

	const verify = async () => {
		try {
			//  Save existing data
			let requestData = {
				registrationToken: $model.RegistrationToken,
				validationCode: validationCode
			};

			let url = "/api/code-validation";

			let response = await post(url, requestData);

			//  Get the Registration Data
			url = `/api/registration?token=${$model.RegistrationToken}&key=${response.sessionToken}`;
			let registration = await get(url);

			$model = registration;
			$model.sessionToken = response.sessionToken;

			return true;
		} catch (err) {
			console.log("Unexpected result:", err);
			validationFailed = true;
			validationCode = null;
			return false;
		}
	};

	const navigateNext = () => {
		navigate("/Registration/PersonalDetails");

		window.scrollTo({ top: 0, behavior: "smooth" });
	};

	const handleKeyDown = (e) => {
		if (e.key === "Enter") {
			validateCode();
			return true;
		}
	};

</script>

<PageSection>
	<FormRow class="justify-content-center">
		<FormColumn>
			<h1 class="text-center">{@html projectSettings.classActionName}</h1>
		</FormColumn>
	</FormRow>

	<FormRow class="justify-content-md-center">
		<FormColumn>
			<p>
				Hi {$model.ContactName},
			</p>

			<p>To access your registration form, please complete the following steps:</p>

			<ol>
				<li>Click on the 'send verification code' button below;</li>
				<li>
					You will need access to the mobile number you have previously registered with Shine Lawyers (ending
					in {$model.MaskedPhoneNumber});
				</li>
				<li>
					Enter the verification code that is sent to your mobile (please allow up to 5 minutes for the code
					to come through); and
				</li>
				<li>Click 'Validate'. Once validated, you will be directed to a form to continue your egistration.</li>
			</ol>

			{#if accessTokenRequested}
				<Form id="validate-code" on:submit={() => validateCode()}>
					<FormRow>
						<FormColumn cols="8">
							<input
								class="form-control"
								type="text"
								maxlength="6"
								minlength="6"
								bind:value={validationCode}
								placeholder="Verification Code"
								on:keydown={handleKeyDown}
							/>
						</FormColumn>
						<FormColumn cols="4">
							<PrimaryButton class="btn-page-nav" disabled={nextBtnDisabled}>VALIDATE</PrimaryButton>
						</FormColumn>
					</FormRow>
				</Form>
			{/if}

			{#if validationFailed}
				<p style="color: var(--error-color);">
					The verification code entered does not match the code sent. Please review and try again.
				</p>
			{/if}

			{#if !accessTokenRequested}
				<Form id="request-code" on:submit={() => requestToken()}>
					<FormRow>
						<FormColumn style="display: flex; justify-content: center">
							<PrimaryButton class="btn-page-nav">SEND VERIFICATION CODE</PrimaryButton>
						</FormColumn>
					</FormRow>
				</Form>
			{/if}

			<p>
				If you have any questions or issues accessing your registration form, please contact us on
				<ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
				<ClassActionEmailAddress></ClassActionEmailAddress>.
			</p>
		</FormColumn>
	</FormRow>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}
</style>
